import { render } from "./EDITCardR.vue?vue&type=template&id=55dbce4c&scoped=true"
import script from "./EDITCardR.vue?vue&type=script&lang=js"
export * from "./EDITCardR.vue?vue&type=script&lang=js"

import "./EDITCardR.vue?vue&type=style&index=0&id=55dbce4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dbce4c"]])

export default __exports__